export default "__VITE_ASSET__Cqovv4Lp__"